import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Pagination } from '@morressier/alembic';
import { useQuery } from '@tanstack/react-query';
import {
  fetchAuthorReviewData,
  IFetchOrganizationAndJournalsInfo
} from 'src/api/queries';
import { NoRecordFound } from 'src/pages/ReviewList/EmptyState';
import ListLoader from 'src/components/ListLoader';
import ReviewHistoryItemCard from './ReviewHistoryItem';
import { pluralizeString } from 'src/utils/string';

const LIMIT = 10;

interface IReviewListProps {
  workspaceId: string;
  userId: string;
  organizationData: IFetchOrganizationAndJournalsInfo;
}

const ReviewListTab = ({
  workspaceId,
  userId,
  organizationData
}: IReviewListProps) => {
  const [page, setPage] = useState<number>(1);
  const offset = (page - 1) * LIMIT;

  const { data, isLoading } = useQuery({
    queryKey: ['author-review', { workspaceId, userId, page }],
    queryFn: () => fetchAuthorReviewData(workspaceId, userId, offset, LIMIT)
  });

  const totalPages = data?.total ? Math.ceil(data?.total / LIMIT) : 0;

  return isLoading ? (
    <ListLoader />
  ) : (
    <Flex gap={3} direction="column">
      <Text textStyle="headingItem">
        {' '}
        {data?.total} {pluralizeString('Review', data?.total ?? 0)}{' '}
      </Text>
      {data && data?.items?.length ? (
        <>
          {data.items?.map(data => (
            <ReviewHistoryItemCard
              key={data.id}
              data={data}
              selectedReviewerId={userId}
            />
          ))}
          {totalPages > 1 && (
            <Flex width={'100%'} justifyContent={'center'} marginTop={4}>
              <Pagination
                ariaLabel="My review pagination"
                currentPage={page}
                onPageChange={setPage}
                totalPages={totalPages}
              />
            </Flex>
          )}
        </>
      ) : (
        <NoRecordFound
          title="No Reviews Found"
          subTitle={`This user has not completed any peer reviews in the ${organizationData?.organization?.name} workspace. Their recommendations will appear here once they do.`}
        />
      )}
    </Flex>
  );
};

export default ReviewListTab;
